import { Guid } from './guid'
import { vesselDialog } from '../app/vessels/vesselEdit/vesselEditStore'
import { movementDialog } from '../app/stock/movementEdit/stockMovementStore'
import { dealDialog } from '../app/deals/dealEdit/dealEditStore'
import { truckDialog } from '../app/truck/form/truckFormStore'
import { pricingDialog } from '../app/pricings/pricingDialog'
import { recipeDialog } from '../app/recipes/recipeEditStore'
import { DealPricingType } from '../app/deals/dealModels'

export type PopupType = 'vessel' | 'deal' | 'movement' | 'truck' | 'railCar' | 'pricing' | 'recipe' | ''

export type OpenOptions = {
    productId?: Guid,
    pricingType?: DealPricingType,
    dealType?: string,
    waitCorrelationId?: string
}

let open = (popupType: PopupType, id: Guid | null, options?: OpenOptions) => {
    closeAll()

    if (popupType === 'vessel') vesselDialog.open(id, options?.productId)
    if (popupType === 'deal') dealDialog.open(id, options?.pricingType, options?.dealType)
    if (popupType === 'movement') movementDialog.open(id, undefined, options?.waitCorrelationId)
    if (popupType === 'truck') truckDialog.open(id, 'Road')
    if (popupType === 'railCar') truckDialog.open(id, 'Train')
    if (popupType === 'recipe') recipeDialog.open(id)
}

let closeAll = () => {
    vesselDialog.close()
    movementDialog.close()
    dealDialog.close()
    truckDialog.close()
    pricingDialog.close()
    recipeDialog.close()
}

export let popupNavigator = { open }

export type PopupNavigatorType = typeof popupNavigator